import React, { useMemo } from 'react';
import styled from 'styled-components';
import { withTheme } from '../../../../theme';
import { useElapsedTime } from '@/util/timerHooks';

const Timer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10em;
  font-family: monospace;
  font-weight: 500;
  color: ${({ color }) => color};
`;

export const isSameDate = (date1, date2) =>
  date1.getFullYear() === date2.getFullYear() &&
  date1.getMonth() === date2.getMonth() &&
  date1.getDate() === date2.getDate();

const Label = styled.div`
  opacity: 0.75;
  font-size: 4em;
  color: ${withTheme(theme => theme.textColor.string())};
`;

const leftPad = val => (String(val).length < 2 ? `0${val}` : val);

export const formatDuration = (seconds, settings) => {
  const omitZeroes = settings?.omitZeroes ?? false;
  const hrs = Math.floor(seconds / 3600);
  const mnt = Math.floor((seconds - hrs * 3600) / 60);
  const sec = seconds % 60;

  const base = [hrs, mnt, sec];

  while (base[0] === 0 && base.length > 1 && omitZeroes) {
    base.shift();
  }

  return base.map(value => leftPad(value)).join(':');
};

const TimerDisplay = ({ since, warningThreshold, alertThreshold }) => {
  // Use the proper useElapsedTime hook for elapsed time calculations
  const { elapsedSeconds } = useElapsedTime({
    startTime: since,
    interval: 1000,
    precision: 'second',
  });

  const timerColor = useMemo(() => {
    const wt = warningThreshold != null ? warningThreshold * 60 : null;
    const at = alertThreshold != null ? alertThreshold * 60 : null;

    if (at !== null && elapsedSeconds >= at) {
      return 'red';
    } else if (wt !== null && elapsedSeconds >= wt) {
      return '#FFAD50';
    }
    return withTheme(theme => theme.textColor.string());
  }, [elapsedSeconds, warningThreshold, alertThreshold]);

  return <Timer color={timerColor}>{formatDuration(elapsedSeconds)}</Timer>;
};

const TurnoverClock = props => {
  const cleaningStartedAtDefault = useMemo(() => new Date(), []);

  const start = props?.room?.cleaningStartedAt || cleaningStartedAtDefault;

  return (
    <>
      <Label>Turnover</Label>
      <TimerDisplay since={start} warningThreshold={props.warningThreshold} alertThreshold={props.alertThreshold} />
    </>
  );
};

export default TurnoverClock;
